// extracted by mini-css-extract-plugin
export default {"text":"_843dff12"};